var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('div',{staticClass:"text-right mb-3"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{name:'users.create'}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Criar")])],1),_vm._v(" "),_c('Grid',{attrs:{"name":"usersGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d5a5253","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/users/UsersGrid.vue
// module id = 847
// module chunks = 1